export const isValidNorthAmericanPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return false;

  if (/^(?:\+1)?[ -]?\(?\d{3}\)?[ -]?\d{3}[ -]?\d{4}$/.test(phoneNumber)) {
    return true;
  } else {
    return false;
  }
};
